import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { useToggleable } from '../../../../../hooks';
import { BaseButton } from '../../../../../BaseComponents';
import Conditions from './Conditions/Conditions';
import ModalX from '../../../../../BaseComponents/ModalX';
import { CdnIcon } from '@shared/ui';

interface RenderTriggerProps {
	onClick: () => void;
}

interface Props {
	renderTrigger?: (props: RenderTriggerProps) => React.ReactNode;
	className?: string;
}

const ConditionsModal: React.FC<Props> = ({ renderTrigger, className }) => {
	const { t } = useTranslation('CheckinConditions');
	const { ConditionsModal: theme } = useTheme('Checkin');

	const { isOpen, open, close } = useToggleable(false);

	return (
		<>
			{renderTrigger?.({ onClick: open }) ?? (
				<BaseButton variant="text" className={cn(theme.button, className)} onClick={open}>
					<CdnIcon icon="Info/Details" className={theme.icon} />
					{t('Check-in conditions')}
				</BaseButton>
			)}

			<ModalX
				classes={{
					scrollBody: theme.scrollBody,
					paper: theme.paper
				}}
				isOpen={isOpen}
				onClose={close}
			>
				<Conditions className={theme.conditions} />
			</ModalX>
		</>
	);
};

export default ConditionsModal;
